import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import {
  Card,
  Box,
  Typography,
  Button,
  CircularProgress,
  Divider,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Grid,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { API_ENDPOINTS } from "../../../config/api";
import { ArrowForward } from "@mui/icons-material";
import AccountCircle from "@mui/icons-material/AccountCircle";
// ...existing imports...

const API_URL = API_ENDPOINTS.CUSTOMER_ORDERS.BASE;

const CustomerOrderDetailsContent = () => {
  const { id } = useParams();
  const [customerOrder, setCustomerOrder] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCustomerOrder();
  }, []);

  const fetchCustomerOrder = async () => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      setCustomerOrder(response.data.customerOrder);
      setProducts(response.data.products || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Enquiry details:", error);
      setError("Failed to load Enquiry details. Please try again.");
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
    );
  }

  if (error) {
    return (
      <Typography
        variant="h6"
        sx={{ textAlign: "center", mt: 5, color: "var(--dangerColor)" }}
      >
        {error}
      </Typography>
    );
  }

  if (!customerOrder) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
        Enquiry not found
      </Typography>
    );
  }

  return (
    <Box component="section" className="invoice-wrapper">
      <Box component="div" sx={{ p: 3, margin: "auto" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                boxShadow: 0,
                borderRadius: "8px",
                p: { xs: 2, sm: 4 },
                background: "white",
                border: "1px solid #555555",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "var(--blackColor)" }}
                >
                  Ordered Customer Deatials
                </Typography>
              </Box>
              <Box>
                <Divider sx={{ mb: 3, borderColor: "var(--borderColor)" }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "baseline",
                        gap: "8px",
                      }}
                    >
                      {customerOrder.app_user?.profile_image ? (
                        <img
                          src={customerOrder.app_user.profile_image}
                          alt="Customer Avatar"
                          style={{
                            borderRadius: "50%",
                            width: 200,
                            height: 200,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <AccountCircle
                          sx={{ width: 200, height: 200, color: "#bdbdbd" }}
                        />
                      )}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                        }}
                      >
                        <Typography component="p" sx={{ fontWeight: "bold" }}>
                          Name:{" "}
                        </Typography>
                        <Typography component="p">
                          {customerOrder.app_user?.company_name || "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                        }}
                      >
                        <Typography component="p" sx={{ fontWeight: "bold" }}>
                          Mobile:{" "}
                        </Typography>
                        <Typography component="p">
                          {customerOrder.app_user?.mobile || "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                        }}
                      >
                        <Typography component="p" sx={{ fontWeight: "bold" }}>
                          Email:{" "}
                        </Typography>
                        <Typography component="p">
                          {customerOrder.app_user?.email || "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                        }}
                      >
                        <Typography component="p" sx={{ fontWeight: "bold" }}>
                          Address:{" "}
                        </Typography>
                        <Typography component="p">
                          {[
                            customerOrder.app_user?.street_line,
                            customerOrder.app_user?.city,
                            customerOrder.app_user?.state,
                            customerOrder.app_user?.country,
                            customerOrder.app_user?.pincode,
                          ]
                            .filter(Boolean)
                            .join(", ") || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "baseline",
                        gap: "8px",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        sx={{
                          textTransform: "capitalize",
                          borderRadius: "20px",
                          fontWeight: 600,
                          px: 2,
                          py: 0.5,
                          boxShadow: "none",
                          background:
                            "linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)",
                          "&:hover": {
                            background:
                              "linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)",
                            boxShadow: "none",
                          },
                        }}
                        href={`/ecommerce/appUsers-list/details/${customerOrder.app_user?.id}`}
                      >
                        More Details
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={8}>
            <Card
              sx={{
                boxShadow: 0,
                borderRadius: "8px",
                p: { xs: 2, sm: 4 },
                background: "white",
                border: "1px solid #555555",
              }}
            >
              {/* Header Section */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 3,
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "var(--blackColor)" }}
                >
                  ID: {customerOrder.id}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "var(--blackColor)" }}
                >
                  Date:
                  {new Date(customerOrder.created_at).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Typography>
              </Box>
              <Divider sx={{ mb: 3, borderColor: "var(--borderColor)" }} />

              {/* Products Table */}

              <TableContainer
                component={Paper}
                variant="outlined"
                className="view-custom-table"
                sx={{ border: "1px solid #ccc", mb: 4 }}
              >
                <Table size="small" className="custom-table">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#2c89e9" }}>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Product
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Brand
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ color: "white", fontWeight: 600 }}
                      >
                        Qty(Tons)/Pieces
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.length > 0 ? (
                      products.map((product, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-child(even)": { backgroundColor: "#f9f9f9" },
                          }}
                        >
                          <TableCell>
                            <Typography
                              variant="body2"
                              sx={{ color: "var(--blackColor)" }}
                            >
                              {product.product_type?.name || "N/A"}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="body2"
                              sx={{ color: "var(--blackColor)" }}
                            >
                              {product.brand?.name || "N/A"}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography
                              variant="body2"
                              sx={{ color: "var(--blackColor)" }}
                            >
                              {product.quantity != null
                                ? `${product.quantity} Tons`
                                : `${product.pieces} Pieces`}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "var(--bodyColor)",
                              textAlign: "center",
                            }}
                          >
                            No products selected
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Order Information */}
              <Typography variant="h6" className="sub-title">
                Order Information
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{ display: "flex", alignItems: "baseline", gap: "8px" }}
                  >
                    <Typography component="p" sx={{ fontWeight: "bold" }}>
                      Payment Terms:
                    </Typography>
                    <Typography component="p">
                      {customerOrder.payment_terms === "Credit"
                        ? `${customerOrder.payment_terms} (${customerOrder.payment_terms_description})`
                        : customerOrder.payment_terms}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{ display: "flex", alignItems: "baseline", gap: "8px" }}
                  >
                    <Typography component="p" sx={{ fontWeight: "bold" }}>
                      Delivery Terms:{" "}
                    </Typography>
                    <Typography component="p">
                      {customerOrder.delivery_terms === "Delivered To"
                        ? `${customerOrder.delivery_terms} - ${customerOrder.delivery_address}`
                        : customerOrder.delivery_terms}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{ display: "flex", alignItems: "baseline", gap: "8px" }}
                  >
                    <Typography component="p" sx={{ fontWeight: "bold" }}>
                      Delivery Conditions:{" "}
                    </Typography>{" "}
                    <Typography component="p">
                      {customerOrder.delivery_conditions || "N/A"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{ display: "flex", alignItems: "baseline", gap: "8px" }}
                  >
                    <Typography component="p" sx={{ fontWeight: "bold" }}>
                      Delivery Date:{" "}
                    </Typography>
                    <Typography component="p">
                      {customerOrder.delivery_date === "Within"
                        ? `${customerOrder.delivery_date} (${customerOrder.delivery_date_days} days)`
                        : customerOrder.delivery_date === "Immediate"
                        ? `${customerOrder.delivery_date} (${customerOrder.delivery_date_hours} hours)`
                        : customerOrder.delivery_date || "N/A"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{ display: "flex", alignItems: "baseline", gap: "8px" }}
                  >
                    <Typography component="p" sx={{ fontWeight: "bold" }}>
                      Order By:{" "}
                    </Typography>
                    <Typography component="p">
                      {customerOrder.app_user?.company_name || "N/A"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography
                    variant="p"
                    component="div"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        textTransform: "capitalize",
                        bgcolor:
                          customerOrder.status === "pending"
                            ? "var(--warningColor)"
                            : customerOrder.status === "completed"
                            ? "var(--successColor)"
                            : customerOrder.status === "cancelled"
                            ? "var(--dangerColor)"
                            : "var(--darkColor)",
                        color: "white",
                        "&:hover": {
                          bgcolor:
                            customerOrder.status === "pending"
                              ? "var(--warningColor)"
                              : customerOrder.status === "completed"
                              ? "var(--successColor)"
                              : customerOrder.status === "cancelled"
                              ? "var(--dangerColor)"
                              : "var(--darkColor)",
                        },
                      }}
                    >
                      {customerOrder.status}
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Box className="text-center" sx={{ mt: 3 }}>
          <Link
            className="position-button"
            to="/customer-orders"
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              color="secondary"
              endIcon={<ArrowForward />}
            >
              Back to Page
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerOrderDetailsContent;
